export default async function apiPokeCall({ url, 
    method = "get",
    body, 
    headers,
}){  
    try {
        const response = await fetch(url, {
            method,
            body, 
            headers
        });
        
        return response.json();
    } catch (error) {
        //Lo que hace esto tirar un error y en el lugar donde estoy llamando 
        //a la api
        Promise.reject(error);
    }
}